import { get } from '..';
import { DateRange } from '../../redux/dateRangeSlice';

// eslint-disable-next-line no-unused-vars, no-shadow
export enum AggregationFunction { AVG = 'avg', SUM = 'sum', MAX = 'max' }

interface GetMetricProps {
  metric: string,
  range: DateRange,
  interval?: string,
  deviceNumId?: string,
  aggregationFunction?: AggregationFunction,
  externalId?: string,
}

const GetMetric = ({
  metric, range, interval, deviceNumId, aggregationFunction = AggregationFunction.AVG, externalId,
}: GetMetricProps) => {
  let url: string = `metrics?metric=${metric}`;
  url += `&from=${new Date(range.start).toISOString()}&to=${new Date(range.end).toISOString()}`;
  if (interval) url += `&interval=${interval}`;
  if (deviceNumId) url += `&deviceNumId=${deviceNumId}`;
  if (externalId) url += `&externalId=${externalId}`;
  url += `&aggregationFunction=${aggregationFunction}`;

  return get(url).then((data) => {
    if (!data || data?.isError) return null;
    return data.filter((point) => new Date(point.timestamp) <= new Date());
  });
};

export default GetMetric;
